<script lang="ts">
  export let isExpanded = false;
</script>

<span class="CaretPartial" class:expanded={isExpanded} aria-expanded={isExpanded} />

<style lang="scss">
  @layer standard-components {
    .CaretPartial {
      position: relative;

      &::after {
        content: '›';
        display: inline-block;
        transition: transform var(--duration-slow) var(--easing-sharp);
        transform: rotate(90deg);
      }

      &.expanded {
        &::after {
          transform: translateX(-0.1875em) rotate(-90deg);
        }
      }
    }
  }
</style>
